import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import MobileStepper from '@material-ui/core/MobileStepper';
import { withStyles, createStyles } from '@material-ui/core/styles';
import Button from '../../core/Button';
import Icon from '../../core/Icon';
import withManifest from '../../apps/manifest/withManifest';
var STEP_WIDTH = 800;
var STEP_CONTENT_HEIGHT = 400;
var STEP_HEIGHT = STEP_CONTENT_HEIGHT + 100;

var styles = function styles(theme) {
  return createStyles({
    paper: {
      width: STEP_WIDTH,
      overflow: 'hidden'
    },
    step: {
      position: 'relative',
      width: STEP_WIDTH,
      height: STEP_HEIGHT
    },
    steps: {
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      width: STEP_WIDTH * 10,
      transition: theme.transitions.create('left', {
        duration: theme.transitions.duration.complex
      })
    },
    stepItem: {
      display: 'inline-block',
      width: STEP_WIDTH
    },
    indicator: {
      backgroundColor: 'transparent'
    },
    dot: {
      border: '1px solid white',
      transition: theme.transitions.create('background', {
        duration: theme.transitions.duration.complex
      })
    },
    dotActive: {
      backgroundColor: 'white'
    },
    next: {
      color: 'black'
    },
    back: {
      color: 'white'
    },
    stepContent: {
      height: STEP_CONTENT_HEIGHT,
      maxHeight: STEP_CONTENT_HEIGHT
    },
    stepContentMain: {
      textAlign: 'center',
      paddingTop: STEP_CONTENT_HEIGHT / 3
    },
    stepImage: {
      width: '100%',
      height: '100%'
    },
    stepIcon: {
      width: 64,
      height: 64,
      borderRadius: '50%',
      marginTop: theme.spacing(2)
    }
  });
};
/**
 * @param {import('./types').GuideProps & import('@material-ui/core').WithStyles<typeof styles> & { theme: import('theme/types').EcrionTheme } & import('core/EcrionProvider/types').WithManifest} props
 */


var Guide = function Guide(_ref) {
  var steps = _ref.steps,
      onFinish = _ref.onFinish,
      onCancel = _ref.onCancel,
      color = _ref.color,
      classes = _ref.classes,
      theme = _ref.theme,
      manifest = _ref.manifest;

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      crtStepIdx = _React$useState2[0],
      setStep = _React$useState2[1];

  return React.createElement(Modal, {
    open: true,
    onClose: onCancel,
    "aria-label": "Guide",
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement(Paper, {
    className: classes.paper,
    style: {
      backgroundColor: theme.getColor(color),
      color: theme.palette.getContrastText(theme.getColor(color))
    }
  }, React.createElement("div", {
    className: classes.step
  }, React.createElement("div", {
    className: classes.steps,
    style: {
      left: "-".concat(crtStepIdx * STEP_WIDTH, "px")
    }
  }, steps.map(function (step, index) {
    return React.createElement("div", {
      className: classes.stepItem,
      key: index
    }, Math.abs(crtStepIdx - index) < 2 && React.createElement(React.Fragment, null, React.createElement(StepContent, {
      content: step.content,
      manifest: manifest,
      classes: classes
    }), React.createElement(StepHeader, {
      title: step.title,
      description: step.description
    })));
  }))), React.createElement(StepIndicators, {
    steps: steps.length,
    current: crtStepIdx,
    onChange: setStep,
    onFinish: onFinish,
    classes: classes
  })));
};
/**@param {Pick<import('./types').GuideStep, "content"> & import('core/EcrionProvider/types').WithManifest & import('@material-ui/core').WithStyles<typeof styles>} props */


var StepContent = function StepContent(_ref2) {
  var content = _ref2.content,
      manifest = _ref2.manifest,
      classes = _ref2.classes;
  var contentTitle = content.title;
  var contentIcon = content.icon;
  if (content.title === 'welcome') contentTitle = 'Welcome to ' + manifest.Name;
  if (content.icon === 'app') contentIcon = manifest.IconURL;
  return React.createElement("div", {
    className: classes.stepContent
  }, content.image && React.createElement("img", {
    src: content.image,
    className: classes.stepImage
  }), contentTitle && React.createElement("div", {
    className: classes.stepContentMain
  }, contentTitle && React.createElement(Typography, {
    variant: "h4",
    color: "inherit",
    align: "center",
    gutterBottom: true
  }, contentTitle), contentIcon && React.createElement("img", {
    src: contentIcon,
    className: classes.stepIcon
  })));
};

var StepIndicators = function StepIndicators(_ref3) {
  var steps = _ref3.steps,
      current = _ref3.current,
      onChange = _ref3.onChange,
      onFinish = _ref3.onFinish,
      classes = _ref3.classes;
  return React.createElement(MobileStepper, {
    variant: "dots",
    steps: steps,
    position: "static",
    activeStep: current,
    classes: {
      root: classes.indicator,
      dot: classes.dot,
      dotActive: classes.dotActive
    },
    nextButton: React.createElement(Button, {
      size: "small",
      color: "inherit",
      className: classes.next,
      onClick: function onClick() {
        return current === steps - 1 ? onFinish() : onChange(current + 1);
      }
    }, current === steps - 1 ? 'Finish' : React.createElement(React.Fragment, null, "Next", React.createElement(Icon, {
      type: "right"
    }))),
    backButton: React.createElement(Button, {
      size: "small",
      variant: "text",
      className: classes.back,
      onClick: function onClick() {
        return onChange(current - 1);
      },
      disabled: current === 0
    }, React.createElement(Icon, {
      type: "left"
    }), "Back")
  });
};
/**@param {Pick<import('./types').GuideStep, "title" | "description"> } props */


var StepHeader = function StepHeader(_ref4) {
  var title = _ref4.title,
      description = _ref4.description;
  return React.createElement("div", {
    style: {
      textAlign: 'center',
      padding: 8,
      paddingTop: 16
    }
  }, React.createElement(Typography, {
    color: "inherit",
    variant: "h5",
    gutterBottom: true
  }, title), React.createElement(Typography, {
    color: "inherit",
    gutterBottom: true
  }, description));
};
/**@type {Partial<import('./types').GuideProps>} */


Guide.defaultProps = {
  color: 'primary',
  steps: [{
    title: 'Follow our starter tips',
    description: 'Guided wizard',
    content: {
      title: 'welcome',
      icon: 'app'
    }
  }]
}; // @ts-ignore

export default withStyles(styles, {
  withTheme: true,
  name: 'ECGuide'
})(withManifest(Guide));